import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';
import { Seo } from '../../types/seo';
import { IFaq } from '../../types/faq';

export type UsaStateUpdateResponse = { success: boolean };

export interface UsaStateUpdateBody {
  name: string,
  description: string,
  tipCreditAllowed: boolean,
  imageId: string | undefined,
  faqs?: IFaq[]
  seo: Seo
}

export interface UsaStateUpdatePayload {
  id: string;
  body: UsaStateUpdateBody
}

export const usaStateUpdate = (payload: UsaStateUpdatePayload): Action<UsaStateUpdatePayload> => ({
  type: actions.usaStateUpdateTrigger.toString(),
  payload,
});

export const usaStateUpdateClear = (): Action => ({
  type: actions.usaStateUpdateClear.toString(),
});

export const usaStateUpdateErrorClear = (): Action => ({
  type: actions.usaStateUpdateErrorReset.toString(),
});

export function* usaStateUpdateRequestSaga({ payload }: Action<UsaStateUpdatePayload>) {
  yield put({
    type: actions.usaStateUpdateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.usaStateUpdateError.toString(),
      payload: {
        message: 'UsaStateUpdate: Parameters not passed.',
      },
    });

    return;
  }

  const { id, body } = payload;

  const a = Array.isArray(body.seo?.keywords) ? body.seo?.keywords.join() : body.seo?.keywords;

  const body1: UsaStateUpdateBody = {
    ...body,
    seo: {
      ...body.seo,
      keywords: a,
    },
  };

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/usa-states/${id}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body1),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<UsaStateUpdateResponse, UsaStateUpdateResponse>(
    response,
    actions.usaStateUpdateSuccess.toString(),
    actions.usaStateUpdateError.toString(),
    false,
    (usaStateUpdateData) => usaStateUpdateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.usaStateUpdateTrigger.toString(),
    defaultProcessingSaga(
      usaStateUpdateRequestSaga,
      {
        error: actions.usaStateUpdateError.toString(),
        locationCancel: actions.usaStateUpdateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.usaStateUpdateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.usaStateUpdateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.usaStateUpdateErrorReset.toString(),
    });
  });
}
